import React from 'react';

import { BubbleContainer, Container, StepTitle, Spacer } from './BubbleTracker.styled';
import { useBreakpoints } from 'utilities/useBreakpoints';

import BubbleStep from './BubbleStep';
import { Status } from './BubbleStep.types';
import { Props } from './BubbleTracker.types';

const BubbleStepTracker = (props: Props) => {
  const { isDesktop } = useBreakpoints();
  const { steps, selectedStep } = props;

  const renderedSteps = steps.flatMap((title, index) => {
    const status = determineStatus(index, selectedStep);
    const elements = [];

    if (index !== 0) {
      const spacerStatus = determineStatus(index, selectedStep);
      elements.push(<Spacer key={`spacer-${index}`} status={spacerStatus} />);
    }

    elements.push(<BubbleStep key={index} withTitles={isDesktop} status={status} title={title} />);

    return elements;
  });

  return !isDesktop ? (
    <Container>
      <BubbleContainer>{renderedSteps}</BubbleContainer>
      {selectedStep >= steps.length ? null : (
        <StepTitle tag="h3" styledAs="h3" noMargin>
          Step {selectedStep + 1}: {steps[selectedStep]}
        </StepTitle>
      )}
    </Container>
  ) : (
    <BubbleContainer>{renderedSteps}</BubbleContainer>
  );
};

const determineStatus = (stepIndex: number, selectedStepIndex: number): Status => {
  if (stepIndex === selectedStepIndex) return 'InProgress';

  if (stepIndex < selectedStepIndex) return 'Completed';

  return 'Todo';
};

export default BubbleStepTracker;
